import { getLogger } from '../diagnostics/logger';
import { CLEAR_FILTER, UPDATE_GRID_STATE } from '../actions/actionTypes';
import { Action } from '../actions/commonActions';
import { HashMap } from '../constants';
import { GridState, GridStatePayload } from '../models/';
import { initialAppState } from '../models/state/appState';
const log = getLogger('simManagement.reducers.gridReducer');

export default function gridReducer(
  state: HashMap<GridState> = initialAppState.grid,
  action: Action<any>,
): HashMap<GridState> {
  switch (action.type) {
    case UPDATE_GRID_STATE: {
      const { payload } = action as Action<GridStatePayload>;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const { gridName, gridState } = payload;
      const nextState = { ...state };
      nextState[gridName] = {
        ...gridState,
      };

      return nextState;
    }
    case CLEAR_FILTER: {
      const { payload } = action as Action<string>;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const nextState: HashMap<GridState> = { ...state };
      const payloadState = state[payload];
      if (payloadState) {
        nextState[payload] = {
          ...payloadState,
          filterState: {},
        };

        return nextState;
      } else {
        return state;
      }
    }
    default:
      return state;
  }
}
